module.exports = __webpack_public_path__ + "static/media/intro-png-sep-2026.463e0fe0.png";